import React, { useEffect, useState } from "react";
import ProfileBar from "./components/ProfileBar";
import PageTitle from "./components/PageTitle";
import { useNavigate, useParams } from "react-router-dom";
import { fetchData } from "./js/main";
import {
  Button,
  Grid,
  Icon,
  LinearProgress,
  Paper,
  TextField,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { conf } from "./const";

export default function Confirm(props) {
  const [invoice, setInvoice] = useState();
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      if (params && navigate) {
        let invoice = await fetchData(
          "get",
          "/v3/invoice/" + params.invoice_id
        );
        if (invoice && invoice._id) {
          if (invoice.bills && invoice.bills[0]) {
            navigate(
              process.env.PUBLIC_URL + "/bill/" + invoice.bills[0].bill_id
            );
          } else setInvoice(invoice);
        }
      }
    })();
  }, [params, navigate]);

  function loadingStatus(status) {
    setLoading(status);
  }

  return (
    <div className="content">
      {invoice && (
        <>
          <ProfileBar profile={props.profile} />
          <PageTitle page={props.page} />

          {loading === true && <LinearProgress />}
          <Grid container spacing={2}>
            <Grid item xs={12} md={7} lg={8}>
              <ShowInvoiceDetail invoice={invoice} />
            </Grid>
            <Grid item xs={12} md={5} lg={4}>
              {invoice.qr_image ? (
                <QRCodeArea
                  qrcode={invoice.qr_image}
                  amount={invoice.amount}
                  invoice_id={invoice._id}
                />
              ) : (
                <ReturnForm
                  invoice={invoice}
                  onLoad={loadingStatus}
                  loading={loading}
                />
              )}
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
}

function ShowInvoiceDetail({ invoice }) {
  const styles = {
    label: { fontSize: ".8rem", fontWeight: "600" },
    value: { paddingBottom: "5px", paddingLeft: "7px" },
  };
  return (
    <Paper sx={{ padding: "15px 10px", marginBottom: "20px" }}>
      <div className="bold" style={{ fontSize: "1.2rem" }}>
        ข้อมูลใบเสร็จ
      </div>
      <div style={{ paddingLeft: "15px", marginTop: "15px" }}>
        <div style={styles.label}>ชื่อผู้ชำระเงิน</div>
        <div style={styles.value}>{invoice.debtor_name}</div>
        <div style={styles.label}>เลขที่ผู้เสียภาษี</div>
        <div style={styles.value}>{invoice.debtor_idx}</div>
        <div style={styles.label}>ที่อยู่</div>
        <div style={styles.value}>{invoice.debtor_address}</div>
        <div style={styles.label}>อีเมล</div>
        <div style={styles.value}>{invoice.debtor_email}</div>
        <div style={styles.label}>รายละเอียด</div>
        <DetailTable details={invoice.details} />
        <div style={styles.label}>รวมเป็นเงิน</div>
        <div style={styles.value}>
          {invoice.amount.toLocaleString("en-US", {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}{" "}
          บาท
        </div>
        <div style={styles.label}>สถานะ</div>
        <div style={styles.value}>
          {invoice.bills[0] ? "ชำระเงินแล้ว" : "รอชำระเงิน"}
        </div>
      </div>
    </Paper>
  );
}

function ReturnForm({ invoice, onLoad, loading }) {
  const navigate = useNavigate();
  const [state, setState] = useState({ change: 0, receive: 0 });
  async function paid() {
    onLoad(true);
    const result = await fetchData("put", "/paid/" + invoice._id);
    if (result && result._id) {
      navigate(process.env.PUBLIC_URL + "/bill/" + result.bill_id);
    }
    onLoad(false);
  }
  return (
    <div>
      <div className="bold" style={{ fontSize: "1.2rem" }}>
        การชำระเงิน
      </div>
      <TableContainer sx={{ marginTop: "10px" }}>
        <Table size="small">
          <TableBody>
            <TableRow>
              <TableCell>
                <div style={{ fontSize: "1.2rem", fontWeight: "500" }}>
                  ยอดเงินรวม
                </div>
                <div>(Total Amount)</div>
              </TableCell>
              <TableCell
                sx={{ width: "200px", fontSize: "1.2rem", fontWeight: "600" }}
                align="right"
              >
                {invoice.amount.toLocaleString("en-US", {
                  style: "decimal",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <div style={{ fontSize: "1.2rem", fontWeight: "500" }}>
                  รับชำระ
                </div>
                <div>(Receive Amount)</div>
              </TableCell>
              <TableCell>
                <TextField
                  variant="outlined"
                  fullWidth
                  type="number"
                  inputProps={{ style: { textAlign: "right" } }}
                  onChange={(e) => {
                    const { value } = e.target;
                    let change = parseFloat(value) - invoice.amount;
                    if (!change) change = 0;
                    setState({ ...state, receive: e.target.value, change });
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <div style={{ fontSize: "1.2rem", fontWeight: "500" }}>
                  เงินทอน
                </div>
                <div>(Change)</div>
              </TableCell>
              <TableCell
                sx={{ width: "200px", fontSize: "1.2rem", fontWeight: "600" }}
                align="right"
              >
                {state.change.toLocaleString("en-US", {
                  style: "decimal",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Button
        color="primary"
        disabled={loading}
        sx={{ marginTop: "20px" }}
        variant="contained"
        size="large"
        fullWidth
        onClick={paid}
        startIcon={<Icon>monetization_on</Icon>}
      >
        Paid
      </Button>
    </div>
  );
}

function DetailTable({ details }) {
  return (
    <div>
      <TableContainer
        sx={{ margin: "5px auto 10px", borderTop: "1px solid #ddd" }}
      >
        <Table size="small">
          <TableBody>
            {details.map((detail, key) => (
              <TableRow key={key} hover>
                <TableCell sx={{ width: "50px" }} align="center">
                  {key + 1}
                </TableCell>
                <TableCell>
                  {detail.biller_name}
                  {detail.description && (
                    <div className="fontSize8">({detail.description})</div>
                  )}
                </TableCell>
                <TableCell sx={{ width: "100px" }} align="right">
                  {detail.amount.toLocaleString("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

function QRCodeArea({ qrcode, amount, invoice_id }) {
  const navigate = useNavigate();
  const [state, setState] = useState({ count: 0, invoice_id });
  useEffect(() => {
    if (state && navigate) {
      setTimeout(async () => {
        const result = await fetchData(
          "get",
          "/v3/invoice/" + state.invoice_id + "/status"
        );
        if (result && result.bills && result.bills[0]) {
          navigate(process.env.PUBLIC_URL + "/bill/" + result.bills[0]);
        } else setState({ ...state, count: state.count + 1 });
      }, 3000);
    }
  }, [state, navigate]);

  return (
    <div
      style={{
        textAlign: "center",
        width: "80%",
        maxWidth: "300px",
        border: "1px solid #ddd",
        margin: "auto",
        paddingBottom: "15px",
      }}
    >
      <div>
        <img
          src={process.env.PUBLIC_URL + "/img/thai_qr_payment.png"}
          alt=""
          style={{ width: "100%" }}
        />
      </div>
      <img
        src={"data:image/png;base64," + qrcode}
        alt=""
        style={{ width: "70%", maxWidth: "200px" }}
      />
      <div
        style={{ fontSize: ".9rem", paddingBottom: "10px" }}
        className="bold"
      >
        {conf.organization.name}
        <br />
        {conf.organization.sub_name}
      </div>
      <div style={{ color: "#060" }} className="bold">
        จำนวนเงิน{" "}
        {amount.toLocaleString("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}{" "}
        บาท
      </div>
    </div>
  );
}
